import { render, staticRenderFns } from "./FeatureRow.vue?vue&type=template&id=2036f5c8&scoped=true&"
import script from "./FeatureRow.vue?vue&type=script&lang=js&"
export * from "./FeatureRow.vue?vue&type=script&lang=js&"
import style0 from "./FeatureRow.vue?vue&type=style&index=0&id=2036f5c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2036f5c8",
  null
  
)

export default component.exports